module.exports = __webpack_public_path__ + "img/Upload_record.c7a5474c.svg";